interface FormatBytesParams {
    inputUnit?: string;
}

export function formatBytes() {

    return (rawInput: string | number, params?: FormatBytesParams): string => {
        const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const inputUnit: string = params?.inputUnit || "bytes";
        const input: number = Number(rawInput);

        if (isNaN(input) || input === 0) {
            return `0 ${(params?.inputUnit) ? params.inputUnit : 'MB'}`;
        }

        const indexOfUnit: number = units.findIndex(value => value?.toLowerCase() == inputUnit?.toLowerCase());
        const bytes: number = input * Math.pow(1024, indexOfUnit);


        // below used from https://stackoverflow.com/a/39906526

        let l = 0;
        let n = bytes || 0;

        while (n >= 1024 && ++l) {
            n = n / 1024;
        }

        return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
    }
}
